module.exports = __webpack_public_path__ + "media/icons/mail-icon-6809d7bb.svg";